<script>
import {ref} from "vue";
import axios from "axios";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useValidation from "@/use/Validation";

export default {
    setup() {
        const {mxRules} = useValidation();
        const {getBack} = useSharedMethod();
        const {dialog, loading} = useSharedData();
        
        const yearMonth = ref(null);
        
        function upload() {
            loading.value = true;
            axios.post(`/sage/paySlips`, null, {
                params: {
                    yearMonth: yearMonth.value,
                }
            }).then(() => {
                getBack();
            }).finally(() => {
                loading.value = false
            });
        }
        
        
        return {
            mxRules,
            dialog,
            loading,
            yearMonth,
            upload,
            getBack
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="600"
        scrollable
    >
        <v-card>
            <w-toolbar color="teal"/>
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row dense>
                            <v-col cols="12">
                                <w-label :label="$t('common.month')" required/>
                                <w-month-picker
                                    v-model="yearMonth"
                                    :rules="mxRules.required"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    show
                    :loading="loading"
                    @press="upload"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<style scoped>

</style>